import { formatCurrency } from "../../../../../utils/utils";
import { createQuestionValueMap, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, Question, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

export const defaultIncomeInformation: Map<string, ConfirmationData> = new Map([
    ["A", { label: "Ingreso anual", value: "", fontWeight: "bold" }],
    ["M", { label: "Ingreso mensual", value: "", fontWeight: "bold" }]
]);

export const updateIncomeInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    const answersMap = createQuestionValueMap(page);
    answersMap.get("4a967829-f99e-499d-bd44-91d655e894b1")
    const iv = processIncomeValue(answersMap.get("4a967829-f99e-499d-bd44-91d655e894b1")?.value)
    return updateMapWithFields(mapToTupleArray(iv), cd);
}


export const processIncomeValue = (input: string | undefined): Map<string, Question> => {
    if (input === undefined) {
        return new Map();
    }
    if (!input) {
        return new Map();
    }
    if (input === '') {
        return new Map();
    }
    const [type, amount] = input.split(',');
    const numericAmount = Math.round(parseFloat(amount));
    const result = new Map<string, Question>();

    if (type === 'A') {
        result.set('A', { value: formatCurrency(numericAmount), hidden: false });
        result.set('M', { value: formatCurrency(Math.round(numericAmount / 12)), hidden: false });
    } else if (type === 'M') {
        result.set('M', { value: formatCurrency(numericAmount), hidden: false });
        result.set('A', { value: formatCurrency(Math.round(numericAmount * 12)), hidden: false });
    }

    return result;
};

